import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import config from "../../../config";
import {
  handleAccept,
  handleClose,
  handleEdit,
  handlePause,
  handleReactivate,
  handleReopen,
} from "../../../utils/Task/taskHandlers";
import { TaskData } from "../../../utils/Task/taskTypes";
import "../Modal.css";
import ConfirmCloseModal from "./ConfirmClose";
import ForwardModal from "./ForwardModal";
import JournalModal from "./JournalModel";
import CommunicationModal from "../Incident/CommunicationModal";
import { authFetch } from "../../../utils/Security/authFetch";
import ChangePhaseModel from "../Change/ChangePhaseModel";
import TaskPhaseModel from "./TaskPhaseModel";
const isAdmin = localStorage.getItem("isAdmin") === "true";

type Message = {
  id: number;
  username: string;
  message: string;
  date: string;
};
type Communication = {
  id: number;
  users: string;
  message: string;
  date: string;
};

type ModalProps = {
  isOpen: boolean;
  data: any;
  onClose: () => void;
};

const hiddenKeys = [
  "isaccepted",
  "isFavorite",
  "isallsite",
  "isclosed",
  "foruserid",
  ,
  "isforwarded",
  "isreopened",
  "isreactivated",
];

// Sections
const ticketInfo = [
  "createdby",
  "username",
  "ticketId",
  "status",
  "phase",
  "ticketCreationDatetime",
  "ticketClosureDatetime",
  "taskStartDatetime",
  "taskCloseDatetime",
  "imapcttaskStartDatetime",
  "impacttaskCloseDatetime",
  "taskResolutionTime",
  "customerapproval",
];
const customerInfo = [
  "affectedCustomer",
  "affectedNetwork",
  "affectedSite",

  "affectedLink",
  "asset",
  "affectedAntenna",
];
const slaInfo = ["reactionPoint", "acceptanceTime", "acceptanceStatus"];
const statusInfo = [
  "summary",
  "description",
  "attachment",
  "solution",
  "tasktype",
  "closureCode",
];
const resInfo = ["responsiblePerson", "responsibleTeam"];
const miscInfo = ["journalUpdate", "changetemplate", "attachments"];
const incInfo = ["priority"];

const relInfo = ["relatedobject", "filePath"];

const fieldLabels: { [key: string]: string } = {
  // Ticket Info
  createdby: "Created By",
  username: "User",
  ticketId: "Ticket ID",
  status: "Status",
  ticketCreationDatetime: "Ticket Creation Date/Time",
  ticketClosureDatetime: "Ticket Closure Date/Time",
  taskStartDatetime: "Planned Start Date/Time",
  taskCloseDatetime: "Planned End Date/Time",
  imapcttaskStartDatetime: "Impact Start Date/Time",
  impacttaskCloseDatetime: "Impact End Date/Time",
  taskResolutionTime: "Impact Period",
  customerapproval: "Customer Approval",

  // Customer Info
  affectedCustomer: "Customer",
  affectedNetwork: "Network",
  affectedSite: "Site",
  affectedLink: "Link",
  asset: "Asset",
  affectedAntenna: "Antenna",

  // SLA Info
  reactionPoint: "Reaction Point",
  acceptanceTime: "Acceptance Time",
  acceptanceStatus: "Acceptance Status",

  // Status Info
  summary: "Summary",
  description: "Description",
  attachment: "Attachment",
  solution: "Solution",
  tasktype: "Task Type",
  closureCode: "Closure Code",

  // Responsible
  responsiblePerson: "Responsible Person",
  responsibleTeam: "Responsible Team",

  // Misc
  journalUpdate: "Journal Update",
  changetemplate: "Change Template",
  attachments: "Attachments",
  filePath: "File Path",
  phase: "Phase",
  // Incident Info
  priority: "Priority",

  // Related
  relatedobject: "Related Object",
};
const formatDate = (dateStr: string): string => {
  if (!dateStr) return "";
  return dateStr.replace("T", " ").split(".")[0];
};
const downloadFile = async (path: string) => {
  try {
    if (!path) return;
    const normalizedPath = path.replace(/\\/g, "/");
    const originalFileName = normalizedPath.split("/").pop();
    if (!originalFileName) return;

    const res = await authFetch(
      `${config.apiBaseUrl}/api/tasks/downloadFile?path=${encodeURIComponent(
        path
      )}`
    );
    if (!res.ok) throw new Error("Failed to download file");

    const blob = await res.blob();
    const url = window.URL.createObjectURL(blob);

    const a = document.createElement("a");
    a.href = url;
    a.download = originalFileName;
    document.body.appendChild(a);
    a.click();
    a.remove();
    window.URL.revokeObjectURL(url);
  } catch (err) {
    console.error("Download error:", err);
  }
};

const Modal: React.FC<ModalProps> = ({ isOpen, data, onClose }) => {
  console.log("ddddddddddddddddddddddddddddd", data);

  const navigate = useNavigate();
  const [selectedTask, setSelectedTask] = useState<TaskData | null>(null);
  const [localTaskData, setLocalTaskData] = useState<any>(data);
  const isAdmin = localStorage.getItem("isAdmin") === "true";
  const [isForwardModalOpen, setIsForwardModalOpen] = useState(false);
  const [journalMessages, setJournalMessages] = useState<Message[]>([]);
  const [showChangePhase, setShowChangePhase] = useState(false);

  const [communicationMessages, setCommunicationMessages] = useState<
    Communication[]
  >([]);
  const [fileImages, setFileImages] = useState<{
    [path: string]: string | null;
  }>({});
  const [username, setUsername] = useState<string>("");

  const [showConfirmClose, setShowConfirmClose] = useState(false);
  const [ShowJournal, setShowJournal] = useState(false);
  const [ShowCommunication, setShowCommunication] = useState(false);
  // New state to track if journal modal is for pause or just journal add
  const [isPauseAction, setIsPauseAction] = useState(false);
  const [journalTitle, setJournalTitle] = useState("Add Journal");

  useEffect(() => {
    if (isOpen) {
      setLocalTaskData(data);
      fetchMessages();
      fetchUsername();
      fetchCommunication();
    }
  }, [isOpen, data]);
  const fetchUsername = async () => {
    if (!data?.userid) return;
    try {
      const res = await authFetch(
        `${config.apiBaseUrl}/api/users/${data.userid}`
      );
      if (!res.ok) throw new Error("User not found");
      const user = await res.json();
      setUsername(user.username || `User #${data.userid}`);
    } catch (err) {
      setUsername(`User #${data.userid}`);
    }
  };
  const closeForwardModal = () => {
    setIsForwardModalOpen(false);
    setSelectedTask(null);
  };
  const renderSection = (title: string, keys: string[], data: any) => (
    <div className="modal-section">
      <h3>{title}</h3>
      <div className="modal-section-content">
        {keys
          .filter(
            (key) =>
              data[key] !== undefined &&
              !hiddenKeys.includes(key) &&
              (isAdmin ||
                ![
                  "reactionPoint",
                  "responseTimeToOpen",
                  "responseTimeToClose",
                  "impact",
                  "priority",
                  "acceptanceTime",
                  "sla",
                  "slaStatus",
                  "relatedobject",
                  "ola",
                  "olaStatus",
                  "incidentCrossReference",
                  "customerComplaint",
                  "customerInformed",
                ].includes(key))
          )
          .map((key, index) => (
            <div key={index} className="modal-item">
              <strong>{fieldLabels[key] || key}:</strong>
              <div className="modal-value">
                {key === "filePath" ? (
                  Array.isArray(data[key]) ? (
                    <ul style={{ listStyle: "none", padding: 0, margin: 0 }}>
                      {data[key].map((path: string | null, i: number) => {
                        if (!path) return null;

                        const normalizedPath = path.replace(/\\/g, "/");
                        const fileName =
                          normalizedPath.split("/").pop() || `File${i + 1}`;
                        const ext = fileName.split(".").pop()?.toLowerCase();
                        const isImage = [
                          "png",
                          "jpg",
                          "jpeg",
                          "gif",
                          "bmp",
                          "webp",
                        ].includes(ext || "");
                        const imgUrl = fileImages[path] || null;

                        return (
                          <li key={i} style={{ marginBottom: "10px" }}>
                            {isImage && imgUrl ? (
                              <img
                                src={imgUrl}
                                alt={fileName}
                                style={{
                                  maxWidth: "100%",
                                  maxHeight: "300px",
                                  borderRadius: "5px",
                                }}
                              />
                            ) : (
                              <button
                                style={{
                                  color: "blue",
                                  textDecoration: "underline",
                                  background: "none",
                                  border: "none",
                                  cursor: "pointer",
                                }}
                                onClick={() => downloadFile(path)}
                              >
                                {fileName}
                              </button>
                            )}
                          </li>
                        );
                      })}
                    </ul>
                  ) : (
                    (() => {
                      const normalizedPath =
                        data[key]?.replace(/\\/g, "/") || "";
                      const fileName =
                        normalizedPath.split("/").pop() || "file";
                      const ext = fileName.split(".").pop()?.toLowerCase();
                      const isImage = [
                        "png",
                        "jpg",
                        "jpeg",
                        "gif",
                        "bmp",
                        "webp",
                      ].includes(ext || "");
                      const fileUrl = `${config.apiBaseUrl}/api/tasks/files/${fileName}`;

                      return isImage ? (
                        <img
                          src={fileUrl}
                          alt={fileName}
                          style={{
                            maxWidth: "100%",
                            maxHeight: "300px",
                            borderRadius: "5px",
                          }}
                        />
                      ) : (
                        <button
                          style={{
                            color: "blue",
                            textDecoration: "underline",
                            background: "none",
                            border: "none",
                            cursor: "pointer",
                          }}
                          onClick={() => downloadFile(data[key])}
                        >
                          {fileName}
                        </button>
                      );
                    })()
                  )
                ) : key === "relatedobject" && data[key] ? (
                  (Array.isArray(data[key])
                    ? data[key]
                    : (data[key] as string).split(",")
                  ).map((item: string, idx: number) => {
                    const ticketId = item.trim();
                    let path = `/incident-edit/${ticketId}`; // default

                    if (ticketId.startsWith("TSK"))
                      path = `/task-edit/${ticketId}`;
                    else if (ticketId.startsWith("CHN"))
                      path = `/change-edit/${ticketId}`;
                    else if (ticketId.startsWith("IND"))
                      path = `/incident-edit/${ticketId}`;

                    return (
                      <React.Fragment key={idx}>
                        <button
                          style={{
                            color: "blue",
                            textDecoration: "underline",
                            background: "none",
                            border: "none",
                            cursor: "pointer",
                            padding: 0,
                            marginRight: 5,
                          }}
                          onClick={() => navigate(path, { state: { data } })}
                        >
                          {ticketId}
                        </button>
                        {idx <
                        (Array.isArray(data[key])
                          ? data[key].length
                          : (data[key] as string).split(",").length) -
                          1
                          ? ", "
                          : ""}
                      </React.Fragment>
                    );
                  })
                ) : key === "userid" ? (
                  username
                ) : key === "userid" ? (
                  "username"
                ) : Array.isArray(data[key]) ? (
                  data[key].join(", ")
                ) : typeof data[key] === "string" ? (
                  ["description", "summary", "solution"].includes(key) ? (
                    <div
                      dangerouslySetInnerHTML={{ __html: data[key] }}
                      style={{ whiteSpace: "normal" }}
                    />
                  ) : /^\d{4}-\d{2}-\d{2}T\d{2}:\d{2}/.test(data[key]) ? (
                    formatDate(data[key])
                  ) : (
                    data[key]
                  )
                ) : (
                  JSON.stringify(data[key], null, 2)
                )}
              </div>
            </div>
          ))}
      </div>
    </div>
  );
  const fetchMessages = async () => {
    if (!data?.ticketId) return;
    const res = await authFetch(
      `${config.apiBaseUrl}/api/messages/ticket/${data.ticketId}`
    );
    if (res.ok) setJournalMessages(await res.json());
  };

  const fetchCommunication = async () => {
    if (!data?.ticketId) return;
    const res = await authFetch(
      `${config.apiBaseUrl}/api/communications/ticket/${data.ticketId}`
    );
    if (res.ok) setCommunicationMessages(await res.json());
  };

  if (!isOpen) return null;

  const isAccepted = data?.isaccepted;
  const isClosed = data?.isclosed;
  const isPaused = data?.ispaused;
  const fetchUpdatedProblem = async (): Promise<TaskData> => {
    const res = await authFetch(
      `${config.apiBaseUrl}/api/tasks/${data.ticketId}`
    );
    return await res.json();
  };
  const handleForward = (data: TaskData) => {
    setSelectedTask(data);
    setIsForwardModalOpen(true);
  };
  const confirmClose = async () => {
    setShowConfirmClose(false);
    onClose();
    await new Promise((resolve) => setTimeout(resolve, 4000));
    const updatedData = await fetchUpdatedProblem();
    await handleClose(updatedData, fetchMessages);
  };

  // When journal modal confirmed:
  // if it's pause action -> call handlePause
  // else just close journal modal and refresh messages (journal add only)
  const onJournalConfirm = () => {
    if (isPauseAction) {
      handlePause(data, fetchMessages);
    } else {
      fetchMessages(); // Refresh journal list
    }
    setShowJournal(false);
    onClose();
    setIsPauseAction(false);
  };

  const addCommunication = () => {
    setShowCommunication(false);
    onClose();
  };

  return (
    <>
      {isForwardModalOpen && (
        <ForwardModal
          isOpen={isForwardModalOpen}
          data={selectedTask}
          onClose={closeForwardModal}
        />
      )}

      {showConfirmClose && (
        <ConfirmCloseModal
          data={data}
          onConfirm={confirmClose}
          onCancel={() => setShowConfirmClose(false)}
        />
      )}
      {showChangePhase && (
        <TaskPhaseModel
          data={data}
          onConfirm={confirmClose}
          onCancel={() => setShowChangePhase(false)}
        />
      )}
      {ShowJournal && (
        <JournalModal
          data={data}
          title={journalTitle}
          onConfirm={onJournalConfirm}
          onCancel={() => {
            setShowJournal(false);
            setIsPauseAction(false);
          }}
        />
      )}

      {ShowCommunication && (
        <CommunicationModal
          data={data}
          onConfirm={addCommunication}
          onCancel={() => setShowCommunication(false)}
        />
      )}

      <div className="modal-overlay">
        <div className="modal-content">
          <div
            className="modal-top-buttons"
            style={{
              position: "sticky",
              top: -32,
              backgroundColor: "#fff",
              zIndex: 100,
              padding: "10px",
              display: "flex",
              flexWrap: "wrap",
              gap: "10px",
            }}
          >
            {!isClosed && isAdmin && (
              <button onClick={() => setShowChangePhase(true)}>
                Change Phase
              </button>
            )}
            {!isClosed && (
              <button onClick={() => navigate(`/task-edit/${data.ticketId}`)}>
                Edit
              </button>
            )}
            {!isAccepted && isAdmin && (
              <button onClick={() => handleAccept(data, fetchMessages)}>
                Accept
              </button>
            )}
            {isAccepted && !isPaused && !isClosed && isAdmin && (
              <>
                <button disabled>Already Accepted</button>
                {/* PAUSE BUTTON opens Journal modal with pause intent */}
                <button
                  onClick={() => {
                    setIsPauseAction(true);
                    setJournalTitle("Pause Task (Add Journal)");

                    setShowJournal(true);
                  }}
                >
                  Pause
                </button>
                <button onClick={() => setShowConfirmClose(true)}>Close</button>
              </>
            )}
            {isPaused && isAdmin && (
              <>
                <button onClick={() => handleReactivate(data, fetchMessages)}>
                  Reactivate
                </button>
                <button onClick={() => setShowConfirmClose(true)}>Close</button>
              </>
            )}
            {isClosed && isAdmin && (
              <button onClick={() => handleReopen(data, fetchMessages)}>
                Reopen
              </button>
            )}
            {isAdmin && !isClosed && (
              <button onClick={() => handleForward(data)}>Forward</button>
            )}
            <button onClick={onClose}>X</button>
          </div>

          <h2
            style={{
              position: "sticky",
              top: 16, // slightly below the buttons
              backgroundColor: "#fff",
              zIndex: 99,
              margin: 0,
              padding: "10px 0",
            }}
          >
            Task Details
          </h2>
          <div className="modal-body">
            {renderSection("Task Information", ticketInfo, data)}
            {renderSection("Customer & Network", customerInfo, data)}
            {renderSection("Task Severity", incInfo, data)}
            {renderSection("Task  Details", statusInfo, data)}
            {renderSection("Responsibility", resInfo, data)}
            {isAdmin && renderSection("OLA", slaInfo, data)}
            {isAdmin && renderSection("Related Object", relInfo, data)}
          </div>

          <div className="messages-container">
            <div className="journal">
              {isAdmin && (
                /* ADD JOURNAL BUTTON: just opens journal modal with no pause */
                <button
                  onClick={() => {
                    setIsPauseAction(false);
                    setShowJournal(true);
                    setJournalTitle("Add Journal");
                  }}
                >
                  Add Journal
                </button>
              )}
              <h3>Journal</h3>
              <ul style={{ listStyle: "none", padding: 0 }}>
                {[...journalMessages]
                  .sort(
                    (a, b) =>
                      new Date(b.date).getTime() - new Date(a.date).getTime()
                  )
                  .map((msg) => (
                    <li
                      key={msg.id}
                      style={{
                        marginBottom: "1rem",
                        wordBreak: "break-word",
                      }}
                    >
                      {/* Username always on its own line */}
                      <div>
                        <strong>{msg.username}</strong>
                      </div>
                      {/* Message always below */}
                      <div
                        dangerouslySetInnerHTML={{ __html: msg.message }}
                        style={{
                          wordBreak: "break-word",
                          overflowWrap: "break-word",
                        }}
                      />

                      <small>{new Date(msg.date).toLocaleString()}</small>
                    </li>
                  ))}
              </ul>
            </div>

            <div className="journal"></div>
          </div>
        </div>
      </div>
    </>
  );
};

export default Modal;
